
// // client/src/components/media/Calendar.jsx
// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import { useParams, useNavigate } from 'react-router-dom';
// import AppFooter from '../AppFooter';
// import {
//   addDays,
//   addWeeks,
//   eachDayOfInterval,
//   endOfDay,
//   endOfMonth,
//   endOfWeek,
//   format,
//   isBefore,
//   isSameDay,
//   isSameMonth,
//   isWithinInterval,
//   parseISO,
//   startOfDay,
//   startOfMonth,
//   startOfWeek,
// } from "date-fns";
// // import { Calendar as CalendarIcon, ChevronLeft, ChevronRight, Clock, MapPin } from "lucide-react";
// import { Calendar as CalendarIcon, ChevronLeft, ChevronRight, Clock, MapPin, List, Plus } from "lucide-react";
// import { Modal, Tabs, Tab, Button } from "react-bootstrap"; // <-- use react-bootstrap only


// // ===== Helpers =====
// const toDate = (v) => {
//   if (!v) return new Date();
//   if (v instanceof Date) return v;
//   if (typeof v === "number") return new Date(v);
//   try { return parseISO(String(v)); } catch {
//     const d = new Date(String(v));
//     return isNaN(d.getTime()) ? new Date() : d;
//   }
// };

// const mapEvent = (e) => {
//   const startRaw = e.start ?? e.start_time ?? e.startDate ?? e.date ?? e.startdate;
//   const endRaw   = e.end   ?? e.end_time   ?? e.endDate   ?? e.date   ?? e.enddate;
//   return {
//     id: e.id ?? e.event_id ?? e._id ?? `${e.title || e.name}-${startRaw}`,
//     title: e.title ?? e.name ?? "Untitled",
//     start: toDate(startRaw),
//     end: toDate(endRaw),
//     allDay: Boolean(e.allDay ?? e.all_day),
//     location: e.location ?? e.place ?? "",
//     description: e.description ?? e.details ?? "",
//     color: e.color ?? undefined,
//   };
// };

// const dayKey = (d) => format(d, "yyyy-MM-dd");

// function useURLTenantId() {
//   const search = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : undefined;
//   const query = search?.get("tenantId") ?? undefined;

//   let segment;
//   if (typeof window !== "undefined") {
//     const parts = window.location.pathname.split("/").filter(Boolean);
//     const idx = parts.findIndex((p) =>
//       ["t", "tenant", "tenants", "tenantid", "tenantId"].includes(p.toLowerCase())
//     );
//     if (idx >= 0 && parts[idx + 1]) segment = parts[idx + 1];
//     if (!segment && parts[0] && /^\d+$/.test(parts[0])) segment = parts[0];
//   }
//   return query ?? segment;
// }

// async function fetchTenantEvents(tenantId) {
//   const endpoints = [
//     `/api/events?tenantId=${tenantId}`,
//     `/api/events/tenant/${tenantId}`,
//     `/api/events/${tenantId}`,
//   ];
//   for (const url of endpoints) {
//     try {
//       const res = await fetch(url, { credentials: "include" });
//       if (!res.ok) continue;
//       const data = await res.json();
//       const arr = Array.isArray(data)
//         ? data
//         : Array.isArray(data?.events)
//         ? data.events
//         : Array.isArray(data?.data)
//         ? data.data
//         : [];
//       if (arr.length) return arr.map(mapEvent);
//     } catch {}
//   }
//   return [];
// }

// function withinDay(d, ev) {
//   const range = { start: startOfDay(ev.start), end: endOfDay(ev.end) };
//   return isWithinInterval(d, range) || isSameDay(ev.start, d) || isSameDay(ev.end, d);
// }

// const Dot = ({ color }) => (
//   <span className="inline-block h-1.5 w-1.5 rounded-full" style={{ backgroundColor: color || undefined }} />
// );

// const EventRow = ({ ev, onClick }) => (
//   <button onClick={() => onClick(ev)} className="w-100 text-start rounded px-3 py-2 border-0 bg-transparent">
//     <div className="d-flex align-items-center gap-2">
//       <Dot color={ev.color} />
//       <div className="flex-grow-1">
//         <div className="fw-medium">{ev.title}</div>
//         <div className="small text-muted d-flex align-items-center gap-2">
//           <Clock size={14} />
//           <span>{format(ev.start, "EEE, MMM d p")} – {format(ev.end, "p")}</span>
//         </div>
//       </div>
//     </div>
//   </button>
// );

// // ===== Main Component =====
// export default function Calendar({
//   tenantId: tenantIdProp,
//   initialView = "month",
//   events: eventsProp,
//   onEventClick,
// }) {
//   const navigate = useNavigate();
//   const [view, setView] = useState(initialView); // "month" | "week" | "day"
//   const [cursor, setCursor] = useState(startOfDay(new Date()));
//   const [events, setEvents] = useState(Array.isArray(eventsProp) ? eventsProp.map(mapEvent) : []);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // Dialog state
//   const [dayDialogOpen, setDayDialogOpen] = useState(false);
//   const [dayDialogDate, setDayDialogDate] = useState(null);
//   const [activeEvent, setActiveEvent] = useState(null);

//   // Resolve tenant + persist
//   const urlTenantId = useURLTenantId();
//   const resolvedTenantId = String(
//     tenantIdProp ?? urlTenantId ?? (typeof window !== "undefined" ? localStorage.getItem("currentTenantId") : "")
//   );

//   useEffect(() => {
//     if (resolvedTenantId) {
//       try { localStorage.setItem("currentTenantId", String(resolvedTenantId)); } catch {}
//     }
//   }, [resolvedTenantId]);

//   // Load events if not passed in
//   const load = useCallback(async () => {
//     if (!resolvedTenantId || (eventsProp && eventsProp.length)) return;
//     setLoading(true);
//     setError(null);
//     try {
//       const data = await fetchTenantEvents(resolvedTenantId);
//       const normalized = data.map((e) => ({
//         ...e,
//         end: isBefore(e.end, e.start) ? addDays(e.start, 1) : e.end,
//       }));
//       normalized.sort((a, b) => a.start.getTime() - b.start.getTime());
//       setEvents(normalized);
//     } catch (err) {
//       setError(err?.message || "Failed to load events");
//     } finally {
//       setLoading(false);
//     }
//   }, [resolvedTenantId, eventsProp]);

//   useEffect(() => { load(); }, [load]);

//   // Calendar math
//   const monthDays = useMemo(() => {
//     const start = startOfWeek(startOfMonth(cursor), { weekStartsOn: 0 });
//     const end = endOfWeek(endOfMonth(cursor), { weekStartsOn: 0 });
//     return eachDayOfInterval({ start, end });
//   }, [cursor]);

//   const weekDays = useMemo(() => {
//     const start = startOfWeek(cursor, { weekStartsOn: 0 });
//     const end = endOfWeek(cursor, { weekStartsOn: 0 });
//     return eachDayOfInterval({ start, end });
//   }, [cursor]);

//   const eventsByDay = useMemo(() => {
//     const map = {};
//     const days = view === "month" ? monthDays : weekDays;
//     days.forEach((d) => { map[dayKey(d)] = []; });
//     events.forEach((ev) => {
//       const range = eachDayOfInterval({ start: startOfDay(ev.start), end: endOfDay(ev.end) });
//       range.forEach((d) => {
//         const k = dayKey(d);
//         if (k in map) map[k].push(ev);
//       });
//     });
//     Object.values(map).forEach((arr) => arr.sort((a, b) => a.start.getTime() - b.start.getTime()));
//     return map;
//   }, [events, monthDays, weekDays, view]);

//   // Actions
//   const prev = () => setCursor((v) => (view === "month" ? addWeeks(v, -4) : addWeeks(v, -1)));
//   const next = () => setCursor((v) => (view === "month" ? addWeeks(v, 4) : addWeeks(v, 1)));
//   const today = () => setCursor(startOfDay(new Date()));
//   const openDay = (d) => { setDayDialogDate(d); setDayDialogOpen(true); };

//   const DayCell = ({ d }) => {
//     const k = dayKey(d);
//     const list = eventsByDay[k] || [];
//     const isOtherMonth = !isSameMonth(d, cursor);

//     return (
//       <div className={`border p-2 rounded ${isOtherMonth ? "bg-light" : "bg-white"}`} style={{ minHeight: 110 }}>
//         <button onClick={() => openDay(d)} className="d-flex w-100 align-items-center justify-content-between btn btn-link p-0 text-decoration-none">
//           <span className={`text-sm fw-semibold ${isSameDay(d, new Date()) ? "text-primary" : ""}`}>
//             {format(d, "EEE d")}
//           </span>
//           <span className="small text-muted">{list.length} events</span>
//         </button>
//         <div className="mt-2 d-flex flex-column gap-1">
//           {list.slice(0, 3).map((ev) => (
//             <div key={`${k}-${ev.id}`} className="d-flex align-items-center gap-2 text-truncate">
//               <Dot color={ev.color} />
//               <button
//                 onClick={() => { if (onEventClick) return onEventClick(ev); setActiveEvent(ev); }}
//                 className="btn btn-link p-0 text-truncate"
//               >
//                 {format(ev.start, "p")} · {ev.title}
//               </button>
//             </div>
//           ))}
//           {list.length > 3 && (
//             <button onClick={() => openDay(d)} className="btn btn-link p-0 small">+{list.length - 3} more</button>
//           )}
//         </div>
//       </div>
//     );
//   };

//   return (
//     // <div className="container py-3">
//     <div className="container py-3" style={{ paddingBottom: 72 }}>
//       {/* Header */}
//       <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
//         <div className="d-flex align-items-center gap-2">
//           <Button variant="outline-secondary" onClick={prev}><ChevronLeft size={16} /></Button>
//           <Button variant="outline-secondary" onClick={next}><ChevronRight size={16} /></Button>
//           <Button variant="secondary" onClick={today}>Today</Button>
//           <div className="ms-2 d-flex align-items-center gap-2 fs-5 fw-semibold">
//             <CalendarIcon size={16} /> {format(cursor, view === "month" ? "MMMM yyyy" : "PPPP")}
//           </div>
//         </div>

//         {/* Tabs (react-bootstrap) */}
//         <Tabs
//           id="calendar-view-tabs"
//           activeKey={view}
//           onSelect={(k) => k && setView(k)}
//           className="mb-0"
//         >
//           <Tab eventKey="month" title="Month" />
//           <Tab eventKey="week" title="Week" />
//           <Tab eventKey="day" title="Day" />
//         </Tabs>
//       </div>

//       {/* Body */}
//       {loading && <div className="border rounded p-3 small text-muted">Loading events…</div>}
//       {error && <div className="border rounded p-3 small text-danger">{error}</div>}

//       {!loading && !error && (
//         <div className="border rounded p-3 bg-white">
//           {view === "month" && (
//             <div className="row row-cols-7 g-2">
//               {monthDays.map((d) => (
//                 <div key={dayKey(d)} className="col"><DayCell d={d} /></div>
//               ))}
//             </div>
//           )}

//           {view === "week" && (
//             <div className="row row-cols-7 g-2">
//               {weekDays.map((d) => (
//                 <div key={dayKey(d)} className="col"><DayCell d={d} /></div>
//               ))}
//             </div>
//           )}

//           {view === "day" && (
//             <div className="border rounded">
//               <div className="px-3 py-2 small text-muted">{format(cursor, "PPPP")}</div>
//               <div className="p-2">
//                 {events.filter((ev) => withinDay(cursor, ev)).map((ev) => (
//                   <EventRow
//                     key={ev.id}
//                     ev={ev}
//                     onClick={(clicked) => {
//                       if (onEventClick) return onEventClick(clicked);
//                       setActiveEvent(clicked);
//                     }}
//                   />
//                 ))}
//                 {events.filter((ev) => withinDay(cursor, ev)).length === 0 && (
//                   <div className="p-4 small text-muted">No events for this day.</div>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Day list dialog */}
//       <Modal show={dayDialogOpen} onHide={() => setDayDialogOpen(false)} size="lg" centered>
//         <Modal.Header closeButton>
//           <Modal.Title>{dayDialogDate ? format(dayDialogDate, "PPPP") : "Day"}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
//           {(dayDialogDate ? events.filter((ev) => withinDay(dayDialogDate, ev)) : []).map((ev) => (
//             <EventRow
//               key={`dlg-${ev.id}`}
//               ev={ev}
//               onClick={(clicked) => {
//                 if (onEventClick) return onEventClick(clicked);
//                 setActiveEvent(clicked);
//               }}
//             />
//           ))}
//           {dayDialogDate && events.filter((ev) => withinDay(dayDialogDate, ev)).length === 0 && (
//             <div className="p-3 small text-muted">No events for this day.</div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setDayDialogOpen(false)}>Close</Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Event detail modal */}
//       <Modal show={!!activeEvent} onHide={() => setActiveEvent(null)} size="lg" centered>
//         {activeEvent && (
//           <>
//             <Modal.Header closeButton>
//               <Modal.Title className="fw-semibold">{activeEvent.title}</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//               <div className="d-flex align-items-center gap-2 small mb-2">
//                 <Clock size={16} />
//                 <span>{format(activeEvent.start, "PPPP p")} – {format(activeEvent.end, "p")}</span>
//               </div>
//               {activeEvent.location && (
//                 <div className="d-flex align-items-center gap-2 small mb-2">
//                   <MapPin size={16} />
//                   <span>{activeEvent.location}</span>
//                 </div>
//               )}
//               {activeEvent.description && <p className="mb-0">{activeEvent.description}</p>}
//             </Modal.Body>
//             <Modal.Footer>
//               <Button variant="secondary" onClick={() => setActiveEvent(null)}>Close</Button>
//             </Modal.Footer>
//           </>
//         )}
//       </Modal>

//       {/* Footer */}
//       {/* <div className="mt-3 small text-muted">
//         Tenant: <span className="font-monospace">{resolvedTenantId || "(none)"}</span>
//       </div> */}
//       {/* Footer */}
//       <div className="mt-3 small text-muted">
//         Tenant: <span className="font-monospace">{resolvedTenantId || "(none)"}</span>
//       </div>

//       <AppFooter
//         buttons={[
//           {
//             icon: <List size={16} />,
//             label: 'Event List',
//             onClick: () => navigate(`/${resolvedTenantId}/events`),
//           },
//           {
//             icon: <Plus size={16} />,
//             label: 'Add Event',
//             // If your route is different, e.g. '/events/add', change this accordingly:
//             onClick: () => navigate(`/${resolvedTenantId}/eventAdd`),
//           },
//         ]}
//       />
//     </div>
//   );
// }


// client/src/components/media/Calendar.jsx

import React, { useCallback, useEffect, useMemo, useState } from "react";

import { useNavigate } from 'react-router-dom';

import AppFooter from '../AppFooter';

import {

  addDays,

  addWeeks,

  eachDayOfInterval,

  endOfDay,

  endOfMonth,

  endOfWeek,

  format,

  isBefore,

  isSameDay,

  isSameMonth,

  isWithinInterval,

  parseISO,

  startOfDay,

  startOfMonth,

  startOfWeek,

} from "date-fns";

import { Calendar as CalendarIcon, ChevronLeft, ChevronRight, Clock, MapPin, List, Plus } from "lucide-react";

import { Modal, Tabs, Tab, Button } from "react-bootstrap";

 

// ===== Helpers =====

const toDate = (v) => {

  if (!v) return new Date();

  if (v instanceof Date) return v;

  if (typeof v === "number") return new Date(v);

  try { return parseISO(String(v)); } catch {

    const d = new Date(String(v));

    return isNaN(d.getTime()) ? new Date() : d;

  }

};

 

const mapEvent = (e) => {

  const startRaw = e.start ?? e.start_time ?? e.startDate ?? e.date ?? e.startdate;

  const endRaw   = e.end   ?? e.end_time   ?? e.endDate   ?? e.date   ?? e.enddate;

  return {

    id: e.id ?? e.event_id ?? e._id ?? `${e.title || e.name}-${startRaw}`,

    title: e.title ?? e.name ?? "Untitled",

    start: toDate(startRaw),

    end: toDate(endRaw),

    allDay: Boolean(e.allDay ?? e.all_day),

    location: e.location ?? e.place ?? "",

    description: e.description ?? e.details ?? "",

    color: e.color ?? undefined,

  };

};

 

const dayKey = (d) => format(d, "yyyy-MM-dd");

 

function useURLTenantId() {

  const search = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : undefined;

  const query = search?.get("tenantId") ?? undefined;

 

  let segment;

  if (typeof window !== "undefined") {

    const parts = window.location.pathname.split("/").filter(Boolean);

    const idx = parts.findIndex((p) =>

      ["t", "tenant", "tenants", "tenantid", "tenantId"].includes(p.toLowerCase())

    );

    if (idx >= 0 && parts[idx + 1]) segment = parts[idx + 1];

    if (!segment && parts[0] && /^\d+$/.test(parts[0])) segment = parts[0];

  }

  return query ?? segment;

}

 

async function fetchTenantEvents(tenantId) {

  const endpoints = [

    `/api/events?tenantId=${tenantId}`,

    `/api/events/tenant/${tenantId}`,

    `/api/events/${tenantId}`,

  ];

  for (const url of endpoints) {

    try {

      const res = await fetch(url, { credentials: "include" });

      if (!res.ok) continue;

      const data = await res.json();

      const arr = Array.isArray(data)

        ? data

        : Array.isArray(data?.events)

        ? data.events

        : Array.isArray(data?.data)

        ? data.data

        : [];

      if (arr.length) return arr.map(mapEvent);

    } catch {}

  }

  return [];

}

 

function withinDay(d, ev) {

  const range = { start: startOfDay(ev.start), end: endOfDay(ev.end) };

  return isWithinInterval(d, range) || isSameDay(ev.start, d) || isSameDay(ev.end, d);

}

 

const Dot = ({ color }) => (

  <span className="inline-block h-1.5 w-1.5 rounded-full" style={{ backgroundColor: color || undefined }} />

);

 

const EventRow = ({ ev, onClick }) => (

  <button onClick={() => onClick?.(ev)} className="w-100 text-start rounded px-3 py-2 border-0 bg-transparent">

    <div className="d-flex align-items-center gap-2">

      <Dot color={ev.color} />

      <div className="flex-grow-1">

        <div className="fw-medium">{ev.title}</div>

        <div className="small text-muted d-flex align-items-center gap-2">

          <Clock size={14} />

          <span>{format(ev.start, "EEE, MMM d p")} – {format(ev.end, "p")}</span>

        </div>

      </div>

    </div>

  </button>

);

 

// Row variant that acts as a real hyperlink (for day popup)

function EventRowLink({ ev, to, navigate }) {

  const handleNav = (e) => {

    // Support cmd/ctrl click to open in new tab

    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

    e.preventDefault();

    if (to) navigate(to);

  };

  return (

    <div className="w-100 rounded px-3 py-2">

      <div className="d-flex align-items-center gap-2">

        <Dot color={ev.color} />

        <div className="flex-grow-1">

          <a href={to || '#'} onClick={handleNav} className="fw-medium link-primary text-decoration-underline">

            {ev.title}

          </a>

          <div className="small text-muted d-flex align-items-center gap-2">

            <Clock size={14} />

            <span>{format(ev.start, "EEE, MMM d p")} – {format(ev.end, "p")}</span>

          </div>

        </div>

      </div>

    </div>

  );

}

 

// ===== Main Component =====

export default function Calendar({

  tenantId: tenantIdProp,

  initialView = "month",

  events: eventsProp,

  onEventClick,

}) {

  const navigate = useNavigate();

  const [view, setView] = useState(initialView); // "month" | "week" | "day"

  const [cursor, setCursor] = useState(startOfDay(new Date()));

  const [events, setEvents] = useState(Array.isArray(eventsProp) ? eventsProp.map(mapEvent) : []);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);

 

  // Dialog state

  const [dayDialogOpen, setDayDialogOpen] = useState(false);

  const [dayDialogDate, setDayDialogDate] = useState(null);

  const [activeEvent, setActiveEvent] = useState(null);

 

  // Resolve tenant + persist

  const urlTenantId = useURLTenantId();

  const resolvedTenantId = String(

    tenantIdProp ?? urlTenantId ?? (typeof window !== "undefined" ? localStorage.getItem("currentTenantId") : "")

  );

 

  useEffect(() => {

    if (resolvedTenantId) {

      try { localStorage.setItem("currentTenantId", String(resolvedTenantId)); } catch {}

    }

  }, [resolvedTenantId]);

 

  // Load events if not passed in

  const load = useCallback(async () => {

    if (!resolvedTenantId || (eventsProp && eventsProp.length)) return;

    setLoading(true);

    setError(null);

    try {

      const data = await fetchTenantEvents(resolvedTenantId);

      const normalized = data.map((e) => ({

        ...e,

        end: isBefore(e.end, e.start) ? addDays(e.start, 1) : e.end,

      }));

      normalized.sort((a, b) => a.start.getTime() - b.start.getTime());

      setEvents(normalized);

    } catch (err) {

      setError(err?.message || "Failed to load events");

    } finally {

      setLoading(false);

    }

  }, [resolvedTenantId, eventsProp]);

 

  useEffect(() => { load(); }, [load]);

 

  // Calendar math

  const monthDays = useMemo(() => {

    const start = startOfWeek(startOfMonth(cursor), { weekStartsOn: 0 });

    const end = endOfWeek(endOfMonth(cursor), { weekStartsOn: 0 });

    return eachDayOfInterval({ start, end });

  }, [cursor]);

 

  const weekDays = useMemo(() => {

    const start = startOfWeek(cursor, { weekStartsOn: 0 });

    const end = endOfWeek(cursor, { weekStartsOn: 0 });

    return eachDayOfInterval({ start, end });

  }, [cursor]);

 

  // Associate multiple events per day across full start/end range

  const eventsByDay = useMemo(() => {

    const map = {};

    const days = view === "month" ? monthDays : weekDays;

    days.forEach((d) => { map[dayKey(d)] = []; });

    events.forEach((ev) => {

      const range = eachDayOfInterval({ start: startOfDay(ev.start), end: endOfDay(ev.end) });

      range.forEach((d) => {

        const k = dayKey(d);

        if (k in map) map[k].push(ev);

      });

    });

    Object.values(map).forEach((arr) => arr.sort((a, b) => a.start.getTime() - b.start.getTime()));

    return map;

  }, [events, monthDays, weekDays, view]);

 

  // Actions

  const prev = () => setCursor((v) => (view === "month" ? addWeeks(v, -4) : addWeeks(v, -1)));

  const next = () => setCursor((v) => (view === "month" ? addWeeks(v, 4) : addWeeks(v, 1)));

  const today = () => setCursor(startOfDay(new Date()));

  const openDay = (d) => { setDayDialogDate(d); setDayDialogOpen(true); };

 

  const eventDetailPath = (tenantId, eventId) =>

    tenantId && eventId ? `/${tenantId}/${eventId}/eventDetail` : '#';

 

  const DayCell = ({ d }) => {

    const k = dayKey(d);

    const list = eventsByDay[k] || [];

    const isOtherMonth = !isSameMonth(d, cursor);

 

    return (

      <div className={`border p-2 rounded ${isOtherMonth ? "bg-light" : "bg-white"}`} style={{ minHeight: 110 }}>

        <button onClick={() => openDay(d)} className="d-flex w-100 align-items-center justify-content-between btn btn-link p-0 text-decoration-none">

          <span className={`text-sm fw-semibold ${isSameDay(d, new Date()) ? "text-primary" : ""}`}>

            {format(d, "EEE d")}

          </span>

          <span className="small text-muted">{list.length} {list.length === 1 ? 'event' : 'events'}</span>

        </button>

        <div className="mt-2 d-flex flex-column gap-1">

          {list.slice(0, 3).map((ev) => (

            <div key={`${k}-${ev.id}`} className="d-flex align-items-center gap-2 text-truncate">

              <Dot color={ev.color} />

              <button

                onClick={() => { if (onEventClick) return onEventClick(ev); setActiveEvent(ev); }}

                className="btn btn-link p-0 text-truncate"

                title="Quick view"

              >

                {format(ev.start, "p")} · {ev.title}

              </button>

            </div>

          ))}

          {list.length > 3 && (

            <button onClick={() => openDay(d)} className="btn btn-link p-0 small">+{list.length - 3} more</button>

          )}

        </div>

      </div>

    );

  };

 

  return (

    <div className="container py-3" style={{ paddingBottom: 72 }}>

      {/* Header */}

      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">

        <div className="d-flex align-items-center gap-2">

          <Button variant="outline-secondary" onClick={prev}><ChevronLeft size={16} /></Button>

          <Button variant="outline-secondary" onClick={next}><ChevronRight size={16} /></Button>

          <Button variant="secondary" onClick={today}>Today</Button>

          <div className="ms-2 d-flex align-items-center gap-2 fs-5 fw-semibold">

            <CalendarIcon size={16} /> {format(cursor, view === "month" ? "MMMM yyyy" : "PPPP")}

          </div>

        </div>

 

        <Tabs id="calendar-view-tabs" activeKey={view} onSelect={(k) => k && setView(k)} className="mb-0">

          <Tab eventKey="month" title="Month" />

          <Tab eventKey="week" title="Week" />

          <Tab eventKey="day" title="Day" />

        </Tabs>

      </div>

 

      {/* Body */}

      {loading && <div className="border rounded p-3 small text-muted">Loading events…</div>}

      {error && <div className="border rounded p-3 small text-danger">{error}</div>}

 

      {!loading && !error && (

        <div className="border rounded p-3 bg-white">

          {view === "month" && (

            <div className="row row-cols-7 g-2">

              {monthDays.map((d) => (

                <div key={dayKey(d)} className="col"><DayCell d={d} /></div>

              ))}

            </div>

          )}

 

          {view === "week" && (

            <div className="row row-cols-7 g-2">

              {weekDays.map((d) => (

                <div key={dayKey(d)} className="col"><DayCell d={d} /></div>

              ))}

            </div>

          )}

 

          {view === "day" && (

            <div className="border rounded">

              <div className="px-3 py-2 small text-muted">{format(cursor, "PPPP")}</div>

              <div className="p-2">

                {events.filter((ev) => withinDay(cursor, ev)).map((ev) => (

                  <EventRow

                    key={ev.id}

                    ev={ev}

                    onClick={(clicked) => {

                      if (onEventClick) return onEventClick(clicked);

                      setActiveEvent(clicked);

                    }}

                  />

                ))}

                {events.filter((ev) => withinDay(cursor, ev)).length === 0 && (

                  <div className="p-4 small text-muted">No events for this day.</div>

                )}

              </div>

            </div>

          )}

        </div>

      )}

 

      {/* Day list dialog (each event is a hyperlink to Event Detail) */}

      <Modal show={dayDialogOpen} onHide={() => setDayDialogOpen(false)} size="lg" centered>

        <Modal.Header closeButton>

          <Modal.Title>{dayDialogDate ? format(dayDialogDate, "PPPP") : "Day"}</Modal.Title>

        </Modal.Header>

        <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>

          {(dayDialogDate ? events.filter((ev) => withinDay(dayDialogDate, ev)) : []).map((ev) => (

            <EventRowLink

              key={`dlg-${ev.id}`}

              ev={ev}

              to={eventDetailPath(resolvedTenantId, ev.id)}

              navigate={navigate}

            />

          ))}

          {dayDialogDate && events.filter((ev) => withinDay(dayDialogDate, ev)).length === 0 && (

            <div className="p-3 small text-muted">No events for this day.</div>

          )}

        </Modal.Body>

        <Modal.Footer>

          <Button variant="secondary" onClick={() => setDayDialogOpen(false)}>Close</Button>

        </Modal.Footer>

      </Modal>

 

      {/* Event quick-view modal (unchanged) */}

      <Modal show={!!activeEvent} onHide={() => setActiveEvent(null)} size="lg" centered>

        {activeEvent && (

          <>

            <Modal.Header closeButton>

              <Modal.Title className="fw-semibold">{activeEvent.title}</Modal.Title>

            </Modal.Header>

            <Modal.Body>

              <div className="d-flex align-items-center gap-2 small mb-2">

                <Clock size={16} />

                <span>{format(activeEvent.start, "PPPP p")} – {format(activeEvent.end, "p")}</span>

              </div>

              {activeEvent.location && (

                <div className="d-flex align-items-center gap-2 small mb-2">

                  <MapPin size={16} />

                  <span>{activeEvent.location}</span>

                </div>

              )}

              {activeEvent.description && <p className="mb-0">{activeEvent.description}</p>}

            </Modal.Body>

            <Modal.Footer>

              <Button

                variant="primary"

                onClick={() => navigate(eventDetailPath(resolvedTenantId, activeEvent.id))}

              >

                Open Event

              </Button>

              <Button variant="secondary" onClick={() => setActiveEvent(null)}>Close</Button>

            </Modal.Footer>

          </>

        )}

      </Modal>

 

      {/* Footer */}

      <div className="mt-3 small text-muted">

        Tenant: <span className="font-monospace">{resolvedTenantId || "(none)"}</span>

      </div>

 

      <AppFooter

        buttons={[

          {

            icon: <List size={16} />,

            label: 'Event List',

            onClick: () => navigate(`/${resolvedTenantId}/events`),

          },

          {

            icon: <Plus size={16} />,

            label: 'Add Event',

            onClick: () => navigate(`/${resolvedTenantId}/eventAdd`),

          },

        ]}

      />

    </div>

  );

}
